import { useLayoutEffect } from 'react';

import { useAppSelector } from '@store/store';
import { selectBrandingFaviconLinks } from '@store/slices/settingsSlice.tsx';
import { applyBrandingFaviconLinks } from '@tools/head/applyFaviconFromSettings.ts';

export function useApplyBrandingFavicons(): void {
  const links = useAppSelector(selectBrandingFaviconLinks);

  useLayoutEffect(() => {
    applyBrandingFaviconLinks(links);

    return () => {
      applyBrandingFaviconLinks([]);
    };
  }, [links]);
}
